import COUNTRY_STATES from '../../../../../Static/data/country_states';

function CareProApplyBlockInitializer() {
    let url = document.querySelector('#marketSelect').closest('form').dataset.marketDataUrl;
    if (!url)
        return;

    let modelID = document.querySelector('#marketSelect').closest('section').id;

    getData(url)
        .then((response) => {
            window.jobMarkets = response.markets;
            populateMarketSelect(response.markets);
        })
        .catch((error) => {

        })
        .then(() => {

        });

    async function getData(url = '') {
        const config = {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: { "Content-Type": "application/json; charset=utf-8" },
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        };

        const response = await fetch(url, config);

        return response.json();
    }

    function populateMarketSelect(markets) {
        let select = document.getElementById('marketSelect');
        clearMarketSelect();

        if (markets.length == 0)
            return;

        let selectedOption = null;

        let countries = [...new Set(markets.map(a => a.country))].sort();
        countries.forEach((country) => {
            let states = [...new Set(markets.filter(m => m.country === country).map(a => a.state))].sort();

            states.forEach((state) => {
                let grpLabel = COUNTRY_STATES[country].states.filter(s => s.abbreviation === state)[0].name ?? state;
                let grp = document.createElement('optgroup');
                grp.label = grpLabel + (countries.length == 1 ? '' : `, ${country}`);
                let marketsInState = [...new Set(markets.filter(m => m.country === country && m.state === state))].sort();

                marketsInState.forEach((market) => {
                    if (!isNullOrWhitespace(market.publishDate)) {
                        let pubDate = new Date(market.publishDate);
                        if (pubDate > new Date())
                            return;
                    }

                    let option = document.createElement('option');
                    option.value = market.id;
                    option.innerHTML = market.label;
                    grp.appendChild(option);

                    if (window.SelectedMarket != null && market.label.startsWith(window.SelectedMarket.label)) {
                        selectedOption = option;
                        option.selected = true;
                    }
                });

                select.appendChild(grp);
            });
        });

        addMarketSelectListeners();

        if (selectedOption != null) {
            window.jobMarkets.forEach((market, i) => {
                if (window.SelectedMarket != null && market.label.startsWith(window.SelectedMarket.label)) {
                    window.SelectedMarket = market;
                    markets.selectedIndex = i;
                    markets.value = market.id;
                }
            });
            let e = new Event('change');
            select.dispatchEvent(e);
        }
    }

    function clearMarketSelect() {
        let select = document.getElementById('marketSelect');

        while (select.firstChild)
            select.removeChild(select.firstChild);

        let disabled = document.createElement('option');
        disabled.selected = true;
        disabled.disabled = true;
        disabled.innerHTML = "Select Location";
        select.appendChild(disabled);
    }

    function addMarketSelectListeners() {
        // Add Care Pro App Event Listeners
        let marketSelect = document.getElementById('marketSelect');
        marketSelect.addEventListener('change', (e) => {
            let formExpanded = document.getElementById('form-expanded');
            formExpanded.classList.add('show');

            let form = document.querySelector('.form');
            form.classList.add('expanded');
            document.querySelector('.care-pro-app').classList.add('expanded');

            let selectedMarket = window.jobMarkets
                .filter((market) => {
                    return market.id == marketSelect[marketSelect.selectedIndex].value;
                })[0];

            let details = window.MarketTemplate;

            details = details.replaceAll('{{MARKET}}', selectedMarket.label);
            let hourly = '$' + selectedMarket.hourlyMin.toFixed(2) + (selectedMarket.hourlyMax ? ' - $' + selectedMarket.hourlyMax.toFixed(2) : '+');
            details = details.replaceAll('{{HOURLY_WAGE}}', hourly);
            if (selectedMarket.weekly > 0)
                details = details.replaceAll('{{WEEKLY_WAGE}}', '$' + selectedMarket.weekly);
            if (selectedMarket.extraPerqs !== undefined && selectedMarket.extraPerqs.length > 0)
                details = details.replaceAll('{{EXTRA_PERQS}}', selectedMarket.extraPerqs.join('</p><p>'));
            else
                details = details.replaceAll('{{EXTRA_PERQS}}', '');

            let jobDetails = document.getElementById('jobDetails');
            jobDetails.innerHTML = details;

            window.SelectedMarket = selectedMarket;

            updateFormValues(form.querySelector('form'));
            addButtonListener();
        });
    }

    function removeEmptyParamsFromUrl(url) {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);

        // Remove empty parameters from the search params
        for (let [key, value] of params.entries()) {
            if (!value) {
                params.delete(key);
            }
        }

        // Update the search params on the URL object and return the updated URL
        urlObj.search = params.toString();
        return urlObj.toString();
    }

    function updateFormValues(form) {
        // Get the currently Select Market
        let serviceArea = window.SelectedMarket.label.split(", ")[0];

        let url = window.SelectedMarket.jobApplicationURL[window.env] || window.jobApplicationURL;

        // Reset the utm_source & utm_campaign based on the ATS being utilized
        // Fountain ATS - Pass the Care Pro Referral through UTM Variables
        if (url.includes("fountain.com") && !isNullOrWhitespace(window.referringCP)) {
            window.utm_source = 'care_pro_referral';
            document.getElementsByName('utm_source')[0].value = 'care_pro_referral';
            window.utm_campaign = window.referringCP;
            document.getElementsByName('utm_campaign')[0].value = window.referringCP;
        }
        // All other ATS - Pass the original UTM Variables Normally
        else {
            window.utm_source = window.original_utm_source;
            document.getElementsByName('utm_source')[0].value = window.original_utm_source;
            window.utm_campaign = window.original_utm_campaign;
            document.getElementsByName('utm_campaign')[0].value = window.original_utm_campaign;
        }

        // Generate the Action URL
        let action = url + "?service_area=" + encodeURIComponent(serviceArea);
        action += "&funnel_id=" + encodeURIComponent(serviceArea);
        action += isNullOrWhitespace(window.utm_source) ? '' : `&utm_source=${window.utm_source}`;
        action += isNullOrWhitespace(window.utm_medium) ? '' : `&utm_medium=${window.utm_medium}`;
        action += isNullOrWhitespace(window.utm_campaign) ? '' : `&utm_campaign=${window.utm_campaign}`;
        action += isNullOrWhitespace(window.referringCP) ? '' : `&short_url_referring_cp_id=${window.referringCP}`;
        action += '&int_source=mkting_website';
        form.action = removeEmptyParamsFromUrl(action);

        // Reset the Hidden Fields
        document.getElementsByName('funnel_id')[0].value = serviceArea;
        document.getElementsByName('service_area')[0].value = serviceArea;
    }

    function addButtonListener() {
        let btn = document.getElementById(`btn-submit-${modelID}`);
        btn.addEventListener('click', () => {
            let spinner = document.getElementById(`spinner-submit-${modelID}`);
            spinner.classList.remove('d-none');
            btn.classList.add('d-none');

            let dlData = {
                'event': 'carepro-form-submit',
                'location': window.SelectedMarket.label,
                'job_id': null,
                'form_id': 'carepro-form-submit',
                'eventCallback': () => {
                    setTimeout(() => {
                        let form = document.querySelector(`#${modelID} form`).submit();
                    }, 1500);
                }
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(dlData);
        });
    }

    function isNullOrWhitespace(input) {
        return !input || !input.trim();
    }

}
export default CareProApplyBlockInitializer();